import React from "react"
import ReactDOM from "react-dom/client"
import "./index.css"
import App from "./App"
import reportWebVitals from "./reportWebVitals"
import { AudioProvider } from "./contexts/AudioContext"
import { GameProvider } from "./contexts/GameContext"
import { LeaderboardProvider } from "./contexts/LeaderboardContext"
import { AdminProvider } from "./contexts/AdminContext"
import { BrowserRouter } from "react-router-dom"
import { HelmetProvider } from "react-helmet-async"
import "./i18n/config" // Initialize i18n

const root = ReactDOM.createRoot(document.getElementById("root"))
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <BrowserRouter>
        <LeaderboardProvider>
          <AudioProvider>
            <GameProvider>
              <AdminProvider>
                <App />
              </AdminProvider>
            </GameProvider>
          </AudioProvider>
        </LeaderboardProvider>
      </BrowserRouter>
    </HelmetProvider>
  </React.StrictMode>,
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()

